var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeMobileLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 20,
  viewBox: "0 0 22 20",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14.438 1.532c-.703 2.248-1.272 5.108-1.272 5.108s2.375-.047 4.49-.053h.745c.966.002 1.8.017 2.208.053.62.055 1 .773 1 .773s.32 1.918 0 3.646c-.195 1.058-.61 1.984-.792 2.586-.838 2.75-2.777 5.799-2.777 5.799l-10.918.02-1.17-2.044V7.134L12.574 0s2.274.222 1.864 1.532M3.97 7.582v11.882H0V7.582z"
})));
export default SvgYoutubeMobileLike;